import { Outlet } from 'react-router-dom';
import Footer from '../layout/Footer';
import Header from '../layout/Header';

const GeneralRoute = () => {  
  return (
    <>
      {/* Login y registro: sin buscador, para no distraer de entrar o crear la cuenta */}
      <Header buscador={false} />
      <div className="layout-general">
        <Outlet />
        <Footer />
      </div>
    </>
  );
};


export default GeneralRoute;